import { render, staticRenderFns } from "./SpecialPricing.vue?vue&type=template&id=5677fd70&scoped=true"
import script from "./SpecialPricing.vue?vue&type=script&lang=js"
export * from "./SpecialPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677fd70",
  null
  
)

export default component.exports